import { render, staticRenderFns } from "./OrganizationAddressEdit.vue?vue&type=template&id=79e281f0&"
import script from "./OrganizationAddressEdit.vue?vue&type=script&lang=js&"
export * from "./OrganizationAddressEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports